import script from "./assistant-set.vue?vue&type=script&setup=true&lang=js"
export * from "./assistant-set.vue?vue&type=script&setup=true&lang=js"

import "./assistant-set.vue?vue&type=style&index=0&id=b6e90756&lang=scss"

const __exports__ = script;

export default __exports__